import React, {
  useState,
  useImperativeHandle,
  forwardRef,
} from 'react';
import PropTypes from 'prop-types';
import 'react-simple-keyboard/build/css/index.css';
import styles from './index.module.scss';
import cn from 'classnames';
import CustomKeyboard from '@components/common/CustomKeyboard/index';

const CashCalculator = forwardRef(({
  maxLength,
  name,
  value = '0.00',
  placeholder,
  onChange,
  preDefinedvalue
}, ref) => {

  const [inputName, setInputName] = useState(`${name}`);
  const [inputs, setInputs] = useState({});

  const handleBlur = () => {
    const element = document.querySelector(`#${name}`);
    element.blur();
  };

  const onClickBtn = (e) => {
    const values =
      e !== '{clear}' &&
      {
        ...inputs,
        [inputName]: inputs[inputName] && preDefinedvalue
          ? inputs[inputName].concat(e)
          : ''.concat(e)
      };

    setInputs({
      ...inputs,
      [inputName]: values[inputName]
    });

    if (e === '{clear}') {
      onChange('0.00');
    } else {
      onChange(Number(values[inputName]));
    }
  };

  useImperativeHandle(ref, () => ({
    setKeyboardValue: () => {}
  }), []);

  return (
    <>
      <div className="col-12 p-0 large-input row mx-0 w-100 justify-content-center align-items-center h-15">
        <input
          id={name}
          type="text"
          name={name}
          className={cn('w-100 h-100 form-control p-2 rounded')}
          placeholder={placeholder}
          value={value}
          onFocus={() => { handleBlur(); setInputName(`${name}`); }}
        />
      </div>

      <div className={cn('px-0 py-2 background-primary p-1 od-app-background-color h-90')}>
        <CustomKeyboard
          onClickBtn={onClickBtn}
          type="numeric"
          isClr
          typed={value}
          btnSize="btn"
          maxLength={maxLength}
          customClass={cn('fs-30 background-primary od-app-background-color', styles.myThemeNumeric)}
        />
      </div>
    </>
  );
});

CashCalculator.propTypes = {
  maxLength: PropTypes.number,
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  preDefinedvalue: PropTypes.bool
};

CashCalculator.defaultProps = {
  maxLength: 10,
  value: '0.00',
  preDefinedvalue: false,
  placeholder: ''
};

export default CashCalculator;
